import React from "react";

const DiscoverBtn = ({ theme }) => {
  return (
    <button
      className={`${
        theme === "dark"
          ? "border border-[#1055EA] text-white hover:bg-black hover:border-opacity-80"
          : "border border-lightTextDesignColor text-darkBgColor hover:text-lightTextDesignColor hover:border-opacity-80"
      } text-xl px-6 py-3 text-center transition-hover duration-300 cursor-pointer flex flex-row justify-center items-center group`}
    >
      Discover More
      <span
        className={`${
          theme === "dark"
            ? "after:bg-lightTextDesignColor group-hover:after:bg-[#1055EA] bg-gradient-to-r from-lightTextDesignColor via-blue-600"
            : "after:bg-blue-600 group-hover:after:bg-lightTextDesignColor bg-gradient-to-r from-lightTextDesignColor via-blue-600"
        } w-20 h-[1px] flex after:-mt-[5px] group-hover:after:translate-x-[70px] bg-white ml-3 mt-1 after:w-3 after:h-3 after:rounded-full after:transition-transform after:duration-500`}
      ></span>
    </button>
  );
};

export default DiscoverBtn;
